interface ProductDrumProps {
  name: string;
  category: string;
}

const LOGO_URL = 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/71c2623268c4a67610df95ce2bd1f062.jpeg';

export default function ProductDrum({ name, category }: ProductDrumProps) {
  return (
    <div className="w-full h-full flex items-center justify-center bg-white relative overflow-hidden">
      {/* Subtle radial glow */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at 50% 60%, rgba(30,79,196,0.06) 0%, transparent 70%)',
        }}
      />

      <div className="flex items-end gap-3 relative" style={{ marginTop: 4 }}>

        {/* ─── TAMBOR 208L ─── */}
        <div className="flex flex-col items-center" style={{ width: 80 }}>
          {/* Drum body */}
          <div className="relative" style={{ width: 72, height: 114 }}>
            {/* Drum shadow/back */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                borderRadius: '50% / 6%',
                background: 'linear-gradient(180deg, #1a3a6e 0%, #0f2557 30%, #0a1f4a 60%, #122d6e 100%)',
              }}
            />
            {/* Drum highlight */}
            <div
              style={{
                position: 'absolute',
                left: 6,
                top: 10,
                bottom: 10,
                width: 16,
                borderRadius: '40%',
                background: 'linear-gradient(90deg, rgba(255,255,255,0.13), transparent)',
              }}
            />
            {/* Ridges */}
            {[16, 48, 80].map((top, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top,
                  height: 3,
                  background: 'rgba(255,255,255,0.08)',
                  borderRadius: 2,
                }}
              />
            ))}

            {/* Drum label — matching tote style */}
            <div
              style={{
                position: 'absolute',
                top: 12,
                left: 6,
                right: 6,
                height: 90,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #1a3a8f 0%, #1e4fc4 50%, #1a3a8f 100%)',
                border: '1px solid rgba(255,255,255,0.2)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                overflow: 'hidden',
              }}
            >
              {/* Gloss highlight */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '30%',
                  background: 'linear-gradient(to bottom, rgba(255,255,255,0.12), transparent)',
                  borderRadius: '3px 3px 0 0',
                }}
              />
              {/* Logo */}
              <div
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '1.5px solid rgba(255,255,255,0.35)',
                  flexShrink: 0,
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                <img src={LOGO_URL} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              {/* Company name */}
              <p style={{ color: 'white', fontWeight: 700, fontSize: 4.2, letterSpacing: '0.03em', textAlign: 'center', lineHeight: 1.1, zIndex: 1, padding: '0 1px' }}>
                POLY ALPHAS
              </p>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 600, fontSize: 3.5, letterSpacing: '0.04em', textAlign: 'center', zIndex: 1 }}>
                CHEMICALS C.A.
              </p>
              {/* Divider */}
              <div style={{ width: 20, height: 0.5, background: 'rgba(255,255,255,0.2)', zIndex: 1 }} />
              {/* Product name */}
              <p
                style={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: 4.8,
                  letterSpacing: '0.03em',
                  textAlign: 'center',
                  lineHeight: 1.15,
                  zIndex: 1,
                  padding: '0 1px',
                }}
              >
                {name.length > 14 ? name.slice(0, 14) + '…' : name}
              </p>
              {/* 208L badge */}
              <div style={{ background: 'rgba(255,255,255,0.18)', borderRadius: 6, padding: '0.5px 4px', zIndex: 1 }}>
                <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 4, fontWeight: 600 }}>208 L</p>
              </div>
            </div>
          </div>

          {/* Drum top ring */}
          <div
            style={{
              width: 72,
              height: 10,
              marginTop: -1,
              borderRadius: '50% / 40%',
              background: 'linear-gradient(180deg, #b0b8c8, #8899aa, #6a7a90)',
              border: '1px solid #6a7a90',
            }}
          />

          {/* Bung caps */}
          <div className="flex gap-3" style={{ marginTop: -1 }}>
            <div
              style={{
                width: 8,
                height: 5,
                borderRadius: '50%',
                background: 'linear-gradient(180deg, #999, #666)',
              }}
            />
            <div
              style={{
                width: 8,
                height: 5,
                borderRadius: '50%',
                background: 'linear-gradient(180deg, #999, #666)',
              }}
            />
          </div>

          {/* Label */}
          <span
            className="px-1.5 py-0.5 rounded-full font-500 mt-1"
            style={{
              fontSize: 8,
              background: 'rgba(30,79,196,0.08)',
              color: '#1e4fc4',
              whiteSpace: 'nowrap',
            }}
          >
            Tambor 208L
          </span>
        </div>

        {/* Divider */}
        <div style={{ width: 1, height: 150, background: 'rgba(0,0,0,0.06)', borderRadius: 1 }} />

        {/* ─── TOTEM IBC 1000L ─── */}
        <div className="flex flex-col items-center" style={{ width: 82 }}>
          {/* Metal cage top bar */}
          <div
            style={{
              width: 78,
              height: 5,
              borderRadius: '3px 3px 0 0',
              background: 'linear-gradient(to bottom, #b0b8c8, #8a9ab0)',
              border: '1px solid #7a8a9a',
            }}
          />

          {/* Main cage + inner tank */}
          <div style={{ width: 78, height: 90, position: 'relative' }}>
            {/* Inner plastic tank */}
            <div
              style={{
                position: 'absolute',
                top: 2,
                left: 3,
                right: 3,
                bottom: 2,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #f8faff 0%, #eef3ff 40%, #dce8ff 100%)',
                border: '1px solid rgba(100,140,220,0.25)',
              }}
            />

            {/* Brand label */}
            <div
              style={{
                position: 'absolute',
                top: 8,
                left: 7,
                right: 7,
                height: 62,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #1a3a8f 0%, #1e4fc4 50%, #1a3a8f 100%)',
                border: '1px solid rgba(255,255,255,0.2)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                overflow: 'hidden',
                zIndex: 2,
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '35%',
                  background: 'linear-gradient(to bottom, rgba(255,255,255,0.12), transparent)',
                  borderRadius: '3px 3px 0 0',
                }}
              />
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '1.5px solid rgba(255,255,255,0.35)',
                  flexShrink: 0,
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                <img src={LOGO_URL} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <p style={{ color: 'white', fontWeight: 700, fontSize: 4.5, letterSpacing: '0.03em', textAlign: 'center', lineHeight: 1.1, zIndex: 1, padding: '0 2px' }}>
                POLY ALPHAS
              </p>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontWeight: 600, fontSize: 3.8, letterSpacing: '0.04em', textAlign: 'center', zIndex: 1 }}>
                CHEMICALS C.A.
              </p>
              <div style={{ width: 24, height: 0.5, background: 'rgba(255,255,255,0.2)', zIndex: 1 }} />
              <p style={{ color: 'white', fontWeight: 700, fontSize: 5, textAlign: 'center', lineHeight: 1.1, zIndex: 1, padding: '0 2px' }}>
                {name.length > 14 ? name.slice(0, 14) + '…' : name}
              </p>
              <div style={{ background: 'rgba(255,255,255,0.18)', borderRadius: 6, padding: '0.5px 4px', zIndex: 1 }}>
                <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 4, fontWeight: 600 }}>1000 L</p>
              </div>
            </div>

            {/* Metal cage — vertical bars */}
            {[0, 16, 32, 48, 64, 74].map((x) => (
              <div key={x} style={{ position: 'absolute', top: 0, bottom: 0, left: x, width: 1.5, background: 'linear-gradient(to bottom, #9aaabb, #7a8a9a)', zIndex: 3, opacity: x === 0 || x === 74 ? 1 : 0.5 }} />
            ))}
            {/* Metal cage — horizontal bars */}
            {[0, 22, 44, 66, 88].map((y) => (
              <div key={y} style={{ position: 'absolute', left: 0, right: 0, top: y, height: 1.5, background: 'linear-gradient(to right, #9aaabb, #7a8a9a)', zIndex: 3, opacity: y === 0 || y === 88 ? 1 : 0.45 }} />
            ))}
          </div>

          {/* Metal cage bottom bar */}
          <div
            style={{
              width: 78,
              height: 5,
              background: 'linear-gradient(to top, #b0b8c8, #8a9ab0)',
              border: '1px solid #7a8a9a',
            }}
          />

          {/* Pallet */}
          <div style={{ width: 84, marginTop: 1 }}>
            <div style={{ width: '100%', height: 5, background: 'linear-gradient(to bottom, #c8b090, #a8906a)', borderRadius: '1px 1px 0 0' }} />
            <div style={{ display: 'flex', gap: 3, padding: '0 3px' }}>
              {[0, 1, 2].map((i) => (
                <div key={i} style={{ flex: 1, height: 7, background: 'linear-gradient(to bottom, #b0986e, #907850)', borderRadius: '0 0 1px 1px' }} />
              ))}
            </div>
          </div>

          {/* Label */}
          <span
            className="px-1.5 py-0.5 rounded-full font-500 mt-1"
            style={{
              fontSize: 8,
              background: 'rgba(30,79,196,0.08)',
              color: '#1e4fc4',
              whiteSpace: 'nowrap',
            }}
          >
            Totem 1000L
          </span>
        </div>
      </div>

      {/* Category tag */}
      <div className="absolute bottom-2 left-0 right-0 flex justify-center">
        <span
          className="px-2 py-0.5 rounded-full font-500"
          style={{
            fontSize: 9,
            background: 'rgba(30,79,196,0.10)',
            border: '1px solid rgba(30,79,196,0.22)',
            color: '#1e4fc4',
          }}
        >
          {category}
        </span>
      </div>
    </div>
  );
}